export const Banner = () => {
  return (
    <section className="hero">
      <img
        className="hero-img responsive-img"
        src="https://ik.imagekit.io/mandeshiagro/assets/landing-page/ma_home_banner1_x-90ZW5yz.png?ik-sdk-version=javascript-1.4.3&updatedAt=1648264723204"
        alt="mandeshi-agro-hero-image"
      />
    </section>
  );
};
